
export const services = [
    {
        title: "React.js & React Native Developer",
        icon: 'https://img.icons8.com/color/48/000000/react-native.png', // React logo icon
    },
    {
        title: "Software Engineer",
        icon: 'https://img.icons8.com/color/48/000000/source-code.png', // Software Engineer icon
    },
    {
        title: "Machine Learning Enthusiast",
        icon: 'https://img.icons8.com/?size=100&id=114322&format=png&color=000000', // Machine Learning icon
    },
    {
        title: "Web & Mobile App Developer",
        icon: 'https://img.icons8.com/color/48/000000/web-design.png', // Web & Mobile Development icon
    },
];


export const name = 'Najiullah';

export const experiences = [
    {
        company: 'Alfa Origin',
        role: 'Mobile Developer (React Native)',
        duration: '15/05/2023 – 01/07/2024 ',
        city: 'Rawalpindi',
        country: 'Pakistan',
        logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_W_EMBGaHGwobl-TpZmBsmjs4MzS_oChXdg&s',

        points: [
            'Developed and maintained high-performance React Native mobile apps.',
            'Collaborated with designers and developers to create responsive user interfaces.',
            'Conducted testing and debugging to improve app stability and functionality.',
            'Integrated third-party APIs to enhance app features.'
        ],
    },
    
    {
        company: 'Light Green',
        role: 'Front-end React.js Developer',
        duration: ' 04/11/2022 – 11/05/2023',
        city: 'Abbottabad',
        country: 'Pakistan',
        logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTcrasEhbq7bK8vlIb2a8rGdZUtUiEGn3G__A&s',

        points: [
            'Developed and maintained responsive web interfaces using React.js.',
            'Integrated APIs and enhanced functionality with back-end teams.',
            'Improved application performance and resolved technical issues.',
            'Contributed to code reviews and team knowledge-sharing.'
        ],
    },
];



export const EMAIL_JS_SERVICE_ID = process.env.REACT_APP_EMAIL_JS_SERVICE_ID;
export const EMAIL_JS_TEMPLATE_ID = process.env.REACT_APP_EMAIL_JS_TEMPLATE_ID;
export const EMAIL_JS_PUBLIC_KEY = process.env.REACT_APP_EMAIL_JS_PUBLIC_KEY;
